/*
 * Copyright Thoughtworks, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import _ from "lodash";
import m from "mithril";
import {f} from "helpers/form_helper";

export const ActionableMessage = {
  view(vnode) {
    const vm = vnode.attrs.vm;
    const config = vm.actionPopup();

    if (config) {
      const hide = () => vm.actionPopup(null);
      const classes = _.uniq(_.compact(["actionable-message", config.class]));
      const BUTTON_DEFAULTS = { class: "button", text: "OK", onclick: hide };

      return <div class={classes.join(" ")}>
        <i class="revert" onclick={config.onabort || hide}></i>
        {config.body}
        {
          _.map(config.buttons, (opts) => {
            const c = _.assign({}, BUTTON_DEFAULTS, opts);
            return m(f.button, {class: c.class, onclick: c.onclick}, c.text);
          })
        }
      </div>;
    }
  }
};
